/**
 * Whiteboard shared constants and configuration.
 * Single source of truth for message types, surfaces, dimensions, and limits.
 * All magic numbers are configurable to support different environments.
 */

/** Logical canvas dimensions - shared coordinate space for tutor and student */
export const LOGICAL_WIDTH = 1000;
export const LOGICAL_HEIGHT = 800;

/** Message types for Daily app-message sync */
export const MESSAGE_TYPES = {
  STROKE: 'whiteboard-stroke',
  CLEAR: 'whiteboard-clear',
  ERASE: 'whiteboard-erase',
  LAYOUT: 'whiteboard-layout',
  ACTIVATE: 'whiteboard-activate',
  CURSOR: 'whiteboard-cursor',
};

/** Cursor update throttle: max per second (both surfaces) */
export const CURSOR_THROTTLE_MS = 66;

/** Default and bounds for whiteboard split ratio (0–1 = whiteboard width / total) */
export const WHITEBOARD_RATIO_DEFAULT = 0.3;
export const WHITEBOARD_RATIO_MIN = 0.15;
export const WHITEBOARD_RATIO_MAX = 0.7;

/** Drawing surface identifiers */
export const SURFACES = {
  WHITEBOARD: 'whiteboard',
  LESSON: 'lesson',
};

/** Valid surface values for validation */
export const VALID_SURFACES = Object.values(SURFACES);

/** Stroke colors by role (tutor vs student) - defaults when no color in payload */
export const STROKE_COLORS = {
  tutor: '#2563eb', // blue
  student: '#16a34a', // green
};

/** Pen color palette for user selection */
export const PEN_COLORS = [
  '#000000', // black
  '#dc2626', // red
  '#2563eb', // blue
  '#16a34a', // green
  '#eab308', // yellow
  '#ea580c', // orange
  '#9333ea', // purple
  '#6b7280', // gray
];

/** Batch interval in ms - collect points before sending */
export const BATCH_INTERVAL_MS = 75;

/** Max messages per second for throttle */
export const THROTTLE_MAX_PER_SECOND = 18;

/** Hit-test tolerance in logical units - how close a click must be to a stroke */
export const HIT_TEST_TOLERANCE = 10;

/** Daily.co app message size limit in bytes */
export const MESSAGE_SIZE_LIMIT_BYTES = 4096;

/** Minimum points required for a valid stroke (single point = dot) */
export const MIN_STROKE_POINTS = 1;
